<template>
  <div class="leave-storage">
    <second-menu-link-content>
      <template v-slot:header>
        <span>商品出库</span>
      </template>
      <template v-slot:content>
        <div class="leave-storage-main">
          <div
            class="addNew"
            v-if="operationList.indexOf(operationsBtns.roleStorageOrderAdd) !== -1"
          >
            <el-button class="btn-blue" @click="toIncreasedOutStorage()">新增</el-button>
          </div>
          <div class="form">
            <el-form :model="formData" ref="formData" label-width="75px" :inline="true">
              <el-form-item label="单号：" prop="number" label-width="45px">
                <el-input
                  class="white"
                  clearable
                  @keyup.enter.native="screen"
                  v-model="formData.number"
                  placeholder="请输入单号"
                ></el-input>
              </el-form-item>
              <el-form-item label="出库时间：" prop="date">
                <el-date-picker
                  v-model="formData.date"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="所属仓库：" prop="warehouse">
                <el-select v-model="formData.warehouse" clearable class="white" placeholder="请选择仓库">
                  <el-option
                    v-for="item in warehouse"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="btn">
              <el-button class="btn-blue" @click="screen">筛选</el-button>
              <el-button class="btn-white" v-if="1>2">导入</el-button>
              <el-button class="btn-text" type="text" @click="resetForm('formData')">重置筛选条件</el-button>
            </div>
          </div>
          <div class="table">
            <el-table :data="tableData" style="width: 100%" v-loading="loading">
              <el-table-column prop="number" label="单号"></el-table-column>
              <el-table-column prop="date" label="出库时间"></el-table-column>
              <el-table-column prop="warehouse" label="所属仓库"></el-table-column>
              <el-table-column prop="userName" label="经办人"></el-table-column>
              <!-- <el-table-column prop="price" label="金额"></el-table-column> -->
              <el-table-column prop="address" label="操作">
                <template slot-scope="scope">
                  <el-button class="btn-text" type="text" @click="goDetail(scope.row.id)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="page">
              <pagination-tpl :total="total" :currentPage="page" @queryChange="updatePage"></pagination-tpl>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import { getDBOperationPermission } from "common/js/storage"; // 权限数据接口
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import DBInventory from "models/db/inventory.js";
const dbInventory = new DBInventory();
export default {
  data() {
    return {
      operationList: [], // 权限列表数据
      // 页面按钮--入库新增
      operationsBtns: {
        roleStorageOrderAdd: "ROLE_STORAGE_order_add"
      },
      formData: {
        number: "",
        date: [],
        warehouse: ""
      },
      form: {
        number: "",
        date: [],
        warehouse: ""
      },
      warehouse: [],
      tableData: [
        // {
        //   id: '12',
        //   number: '45452145',
        //   date: '2019-5-6',
        //   warehouse: '上海市',
        //   userName: '虞姬',
        //   price: 12
        // }
      ], // 表格数据
      page: 1,
      total: 0,
      loading: true
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  },
  created() {
    this.operationList = getDBOperationPermission();
  },
  beforeMount() {
    this.getList();
    this.getWarehouse();
  },
  methods: {
    // 获取仓库数据
    getWarehouse() {
      dbInventory.getDBAllWarehouse().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index, array) => {
            let obj = {};
            obj.name = value.name;
            obj.id = value.id;
            arr.push(obj);
          });
          this.warehouse = arr;
        }
      });
    },
    // 获取列表数据
    getList() {
      let currentPage = this.page;
      let startTime =
        this.form.date && this.form.date.length > 0 ? this.form.date[0] : "";
      let endTime =
        this.form.date && this.form.date.length > 0 ? this.form.date[1] : "";
      let outStockCode = this.form.number;
      let warehouseId = this.form.warehouse;
      dbInventory
        .getDBOutStock(
          currentPage,
          outStockCode,
          startTime,
          endTime,
          warehouseId
        )
        .then(res => {
          this.total = res.result.totalNum;
          if (res.success) {
            let arr = [];
            res.result.items.map((value, index, array) => {
              let obj = {};
              obj.id = value.id;
              obj.number = value.outStockCode;
              obj.date = this.toDate(value.outStockTime);
              obj.userName = value.head;
              obj.warehouse = value.warehouseName;
              arr.push(obj);
            });
            this.loading = false;
            this.tableData = arr;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 新增
    toIncreasedOutStorage() {
      this.$router.push("increased-outStorage");
    },
    // 筛选
    screen() {
      this.form = this.formData;
      this.page = 1;
      this.getList();
    },
    // 清空表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.screen();
    },

    goDetail(id) {
      console.log(this.formData);
      this.$router.push({ path: "outStorage-detail", query: { id: id } });
    },
    // 跳转页码
    updatePage(data) {
      this.page = data.currentPage;
      this.getList();
    },
    // 日期转换
    toDate(val) {
      let date = new Date(val);
      var year = date.getFullYear(); // 取得四位数的年份
      var month = date.getMonth() + 1; // 返回0~11之间的数字，0代表一月，11代表12月
      var day = date.getDate();
      return year + "-" + month + "-" + day;
    }
  }
};
</script>

<style lang="scss" scoped>
.leave-storage {
  width: 100%;
  height: 100%;
  .leave-storage-main {
    width: 100%;
    .addNew {
      margin-bottom: 16px;
      .el-button {
        width: 96px;
      }
    }
    .form {
      background: rgba(245, 247, 250, 1);
      padding: 16px;
      border-radius: 4px;
      margin-bottom: 24px;
      .btn {
        padding-left: 45px;
        display: flex;
        align-items: center;
        .el-button {
          width: 96px;
          margin: 0;
          margin-right: 16px;
        }
      }
    }
    .table {
      width: 100%;
      overflow: hidden;
      .page {
        height: 56px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-pagination {
          height: 28px;
          padding: 0px;
          display: flex;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.leave-storage {
  .leave-storage-main {
    .form {
      .el-form {
        .el-form-item {
          margin-bottom: 16px;
          margin-right: 60px;
          .el-form-item__label {
            padding: 0px;
            line-height: 32px;
          }
          .el-form-item__content {
            line-height: 32px;
          }
        }
      }
    }
  }
}
</style>
